import { useSceneStore } from './sceneStore';
import { useSelectionStore } from './selectionStore';
import { useUIStore } from './uiStore';
import { useMockDataStore } from './mockDataStore';

export { useSceneStore } from './sceneStore';
export { useSelectionStore } from './selectionStore';
export { useUIStore } from './uiStore';
export { useMockDataStore, generateValue, getUnit, getSensorTypeFromUnit } from './mockDataStore';

// Unified hook that combines all stores
export const useVisualizationStore = () => {
  const sceneStore = useSceneStore();
  const selectionStore = useSelectionStore();
  const uiStore = useUIStore();
  const mockDataStore = useMockDataStore();

  return {
    // Scene store
    ...sceneStore,

    // Convenience properties for easier access
    scene: sceneStore.currentScene,

    // Selection store
    selectedObjects: selectionStore.selectedObjectIds,
    hoveredObject: selectionStore.hoveredObjectId,
    transformMode: selectionStore.transformMode,
    transformSpace: selectionStore.transformSpace,
    multiSelectMode: selectionStore.multiSelectMode,
    selectObject: selectionStore.selectObject,
    selectObjects: selectionStore.selectObjects,
    deselectObject: selectionStore.deselectObject,
    deselectAll: selectionStore.deselectAll,
    toggleSelection: selectionStore.toggleSelection,
    selectAll: selectionStore.selectAll,
    setHovered: selectionStore.setHovered,
    setTransformMode: selectionStore.setTransformMode,
    setTransformSpace: selectionStore.setTransformSpace,
    setMultiSelectMode: selectionStore.setMultiSelectMode,
    isSelected: selectionStore.isSelected,
    isHovered: selectionStore.isHovered,
    hasSelection: selectionStore.hasSelection,
    getSelectedCount: selectionStore.getSelectedCount,
    getFirstSelected: selectionStore.getFirstSelected,
    getLastSelected: selectionStore.getLastSelected,

    // UI store
    editorMode: uiStore.editorMode,
    viewMode: uiStore.viewMode,
    panels: uiStore.panels,
    contextMenu: uiStore.contextMenu,
    sidebarCollapsed: uiStore.sidebarCollapsed,
    propertiesPanelWidth: uiStore.propertiesPanelWidth,
    objectLibraryWidth: uiStore.objectLibraryWidth,
    setEditorMode: uiStore.setEditorMode,
    setViewMode: uiStore.setViewMode,
    togglePanel: uiStore.togglePanel,
    setPanelState: uiStore.setPanelState,
    showContextMenu: uiStore.showContextMenu,
    hideContextMenu: uiStore.hideContextMenu,
    toggleSidebar: uiStore.toggleSidebar,
    setSidebarCollapsed: uiStore.setSidebarCollapsed,
    setPropertiesPanelWidth: uiStore.setPropertiesPanelWidth,
    setObjectLibraryWidth: uiStore.setObjectLibraryWidth,
    resetUI: uiStore.resetUI,
    getActiveMode: uiStore.getActiveMode,
    isPanelOpen: uiStore.isPanelOpen,

    // Derived properties for convenience
    visualizationMode: uiStore.viewMode.type,
    showDataLabels: uiStore.viewMode.showLabels,
    showBoundingBoxes: uiStore.viewMode.showBounds,
    showWireframe: uiStore.viewMode.showWireframe,
    isTransforming: false, // This will be managed by transform controls

    // Mock data store
    mockData: {
      devices: {}, // This will be populated from sensorData
      sensors: mockDataStore.sensorData,
      heatmap: mockDataStore.heatmapData,
    },
    sensorData: mockDataStore.sensorData,
    heatmapData: mockDataStore.heatmapData,
    realTimeEnabled: mockDataStore.realTimeEnabled,
    updateInterval: mockDataStore.updateInterval,
    generateMockData: mockDataStore.generateMockData,
    updateSensorData: mockDataStore.updateSensorData,
    toggleRealTime: mockDataStore.toggleRealTime,
    setUpdateInterval: mockDataStore.setUpdateInterval,
    getSensorDataById: mockDataStore.getSensorDataById,
    getHeatmapDataByPosition: mockDataStore.getHeatmapDataByPosition,
  };
};
